import React from "react";
import { Popconfirm } from "antd";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "./styled/screen.styled";

type IConfirmEdit = {
  okText: string;
  cancelText: string;
  handleOnConfirm: () => void;
};

type IConfirmCancelEdit = {
  okText: string;
  cancelText: string;
  formViewOrEditModified: boolean;
  handleOnConfirm: (...args: any[]) => void;
  handleCloseEditUser: () => void;
};

export const ConfirmEdit = ({ handleOnConfirm, okText, cancelText }: IConfirmEdit) => (
  <Popconfirm title={useTranslation({ id: "update_user" })} placement="leftBottom" onConfirm={handleOnConfirm} onCancel={() => false} okText={okText} cancelText={cancelText}>
    <S.RegisterButton type="primary" id="drawer-outbound" htmlType="submit">
      {useTranslation({ id: "save" })}
    </S.RegisterButton>
  </Popconfirm>
);

const isConfirmModalOpen = (formViewOrEditModified) => formViewOrEditModified === true;

export const ConfirmCancelEdit = ({ handleOnConfirm, okText, cancelText, formViewOrEditModified, handleCloseEditUser }: IConfirmCancelEdit) => {
  const CANCEL = useTranslation({ id: "cancel" });
  const CANCEL_EDIT = useTranslation({ id: "cancel_edit" });
  return isConfirmModalOpen(formViewOrEditModified) ? (
    <Popconfirm title={CANCEL_EDIT} placement="rightBottom" onConfirm={handleOnConfirm} onCancel={() => false} okText={okText} cancelText={cancelText}>
      <S.CancelButton htmlType="submit">{CANCEL}</S.CancelButton>
    </Popconfirm>
  ) : (
    <S.CancelButton htmlType="submit" onClick={handleCloseEditUser}>
      {CANCEL}
    </S.CancelButton>
  );
};
